export default "__VITE_ASSET__8f346aae__"